const React = require('react');
const Tooltip = require('@material-ui/core/Tooltip').default;
const ClipboardText = require('../ClipboardText/A');
const CopyIcon = require('../../icons/Copy');


module.exports = (props) => {
  const {
    children,
  } = props;
  const title = props.title || children || '';
  const value = props.value || title;
  const disabledCopy = props.disabledCopy || false;


  return (
    <div className={'layoutRow fhaS fvaC ' + (props.className || '')}>
      <div className="rlv wmax">
        <Tooltip
          title={title}
          placement={props.placement || 'top'}
        >
          <div className="rlv ws tov ov z2 w">
            {children}
          </div>
        </Tooltip>
        {
          value ? (
            <div className="rlv z-1 o0 dn (z3|o100)<2:h">
              <div className="abs slt wmin layoutRow fhaC fvaC">
                {disabledCopy ? null : (
                  <ClipboardText
                    text={value}
                    className="layoutRow fhaC fvaC r5 sq30 ov bg0 mhA"
                  >
                    <CopyIcon
                      className="w19 cF o80"
                    />
                  </ClipboardText>
                )}
              </div>
            </div>
          ) : null
        }
      </div>
    </div>
  );
};
